// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import srvEntity from './entities/srv.json';
import srvMenu from '../pages/srv/menu.json';
import srvFullForm from '../pages/srv/forms/full.json';
import srvContextForm from '../pages/srv/forms/context.json';
import srvMiniForm from '../pages/srv/forms/mini.json';
import srvLookupForm from '../pages/srv/forms/lookup.json';
import srvTableView from '../pages/srv/views/table.json';
import srvStagesView from '../pages/srv/views/stages.json';
import srvCardsView from '../pages/srv/views/cards.json';
import srvInlineView from '../pages/srv/views/inline.json';
import srvBacklogView from '../pages/srv/views/backlog.json';
import srvSplitView from '../pages/srv/views/split.json';
import srvCalendarView from '../pages/srv/views/calendar.json';
import srvDashboardView from '../pages/srv/views/dashboard.json';

/** Тип запису «Опитування» зі сторінками пакета: меню, форми та подання з pages/srv/. */
export const srvDefinition: IRecordTypeDefinition = {
  ...srvEntity,
  views: assembleViewSet({
      table: srvTableView,
      stages: srvStagesView,
      cards: srvCardsView,
      inline: srvInlineView,
      backlog: srvBacklogView,
      split: srvSplitView,
      calendar: srvCalendarView,
      dashboard: srvDashboardView,
  }),
  form: srvFullForm,
  forms: { full: srvFullForm, context: srvContextForm, mini: srvMiniForm, lookup: srvLookupForm },
  menu: srvMenu,
} as IRecordTypeDefinition;
